<template>
    <v-container fluid class="about-acc p-0">
        <vue-headful :title="$t('header.about_us') + $t('title')"></vue-headful>
        <HkiaraceBannerFrame
            :src="require('../../assets/acc.jpg')"
            :label="$t('about_acc.banner_title')"
            :is-banner-only="true"
        >
        </HkiaraceBannerFrame>

        <!--<div class="about-acc-stats-container title-font">-->
            <!--<div class="stats-item" v-for="(stats, index) in statsArr" :key="index">-->
                <!--<div class="stats-number">-->
                    <!--{{stats.number}}-->
                    <!--<span class="sub-label" v-if="stats.isFt">-->
                        <!--ft<sup>2</sup>-->
                    <!--</span>-->
                <!--</div>-->
                <!--<hr>-->
                <!--<div class="stats-label">-->
                    <!--{{$t(stats.text)}}-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->

        <HkiaraceCardDisplayFrame
            class="about-acc-about-hkia"
            image-class="about-acc-about-hkia-image"
            image-min-height="60vh"
            :page-width="pageWidth"
            :is-static-info-card="true"
        >
            <template slot="sub-title">
                {{$t('about_acc.about_hkia_title')}}
            </template>
            <template slot="title">
                {{$t('about_acc.about_hkia_sub_title')}}
            </template>
            <template slot="content">
                <div class="about-acc-desc-content">
                    {{$t('home.description_content')}}
                </div>
            </template>
        </HkiaraceCardDisplayFrame>

        <HkiaraceCardDisplayFrame
            class="about-acc-vision"
            image-class="about-acc-vision-image"
            :is-reverse="true"
            :is-default-order-sm="true"
            image-min-height="60vh"
            :page-width="pageWidth"
            :is-static-info-card="true"
        >
            <template slot="sub-title">
                {{$t('about_acc.vision_title')}}
            </template>
            <template slot="title">
                {{$t('about_acc.vision_sub_title')}}
            </template>
            <template slot="content">
                <div class="about-acc-desc-content">
                    {{$t('about_acc.vision_content')}}
                </div>
            </template>
        </HkiaraceCardDisplayFrame>

        <div class="about-acc-map-container">
            <div class="map-wrapper">
                <div class="map"></div>
            </div>
            <div class="map-description-wrapper">
                <div class="map-description flex-column">
                  <div class="map-title title-font">
                    {{$t('about_acc.map_and_location')}}
                  </div>
                  <div class="map-content" v-html="$t('about_acc.map_and_location_content')"></div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
    import HkiaraceCardDisplayFrame from '../../components/HkiaraceCardDisplayFrame'
    import HkiaraceBannerFrame from '../../components/HkiaraceBannerFrame'
    export default {
        name: 'AboutAcc',
        components: {
            HkiaraceCardDisplayFrame,
            HkiaraceBannerFrame
        },
        data() {
            return {
                pageWidth: window.innerWidth,
                statsArr: [
                    {
                        number: '2k+',
                        text: 'about_acc.no_of_users'
                    },
                    {
                        number: '140',
                        text: 'about_acc.events_held'
                    },
                    {
                        number: '24/7',
                        text: 'about_acc.service_hour'
                    },
                    {
                        number: '40k',
                        isFt: true,
                        text: 'about_acc.total_space'
                    }
                ],
                events: [],
                slideShowDialog: false,
            };
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.pageWidth = window.innerWidth;
                });
            });

            this.loadSlideShow();
        },
        computed: {
            isIE() {
                let userAgent = window.navigator.userAgent;
                var msie = userAgent.indexOf("MSIE ");

                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
                {
                    return true;
                } else {
                    return false;
                }
            },
        },
        methods: {
            showSlideShow() {
                this.slideShowDialog = true
            },
            loadSlideShow() {
                this.$callAPI('hkiarace/event/past/', {page_size: 12, page_no: 0}, function (response) {
                    this.events = response.body.events.map((e) => ({id: e.id, image: '/api/static/' + e.memorable_moment_cover_id, link: e.link}));
                }, null, true);
            },
        }
    }
</script>

<style lang="less">
    .about-acc {
        .about-acc-banner {
            .about-acc-banner-label {
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                color: white;
                font-size: 3rem;
                background-color: rgba(11, 11, 11, 0.2);

                letter-spacing: 1px;
                text-transform: uppercase;

                @media only screen and (max-width: 1200px) {
                    font-size: 2rem;
                }
            }
        }

        .about-acc-stats-container {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin: 0 10%;


            @media only screen and (max-width: 1200px) {
                margin: 0;

                .stats-item {
                    width: 50% !important;
                    padding: 20px !important;

                    &:nth-child(1), &:nth-child(2) {
                        border-bottom: 1px solid rgb(232, 232, 232);
                    }

                    &:last-child {
                        border-right: none !important;
                    }
                }

                .stats-number {
                    font-size: 2.5rem !important;
                    line-height: 2.5rem !important;
                    height: 50px !important;
                }
            }

            .stats-item {
                width: 25%;
                padding: 80px 0;
                border-left: 1px solid rgb(232, 232, 232);

                &:last-child {
                    border-right: 1px solid rgb(232, 232, 232);
                }

                .stats-number {
                    font-size: 4.4rem;
                    line-height: 4.4rem;

                    height: 90px;

                    font-weight: 700;
                    color: rgb(157, 157, 157);

                    .sub-label {
                        font-size: 1rem;
                    }
                }

                hr {
                    width: 24px;
                    margin: auto;
                }

                .stats-label {
                    font-size: 0.8rem;
                    color: rgb(49, 49, 49);
                    letter-spacing: 0.5px;
                    padding-top: 10px;
                }
            }
        }

        .about-acc-desc-content {
            /*font-size: 1.0rem;*/
            /*color: rgba(105, 103, 103, 0.8);*/
            /*line-height: 1.9em;*/
        }

        .about-acc-about-hkia {
            @media only screen and (min-width: 1200px) {
                margin-top: 6rem
            }

            background-color: rgba(239, 239, 239, 1);

            .about-acc-about-hkia-image {
                background-image: url('../../assets/aboutacc.jpg');
            }
        }

        .about-acc-vision {

            @media only screen and (min-width: 1200px) {
                margin: 4rem 6rem;
            }

            .about-acc-vision-image {
                background-image: url('../../assets/aboutacc_vision.png');
            }
        }

        .about-acc-map-container {
            background-color: rgba(239, 239, 239, 1);
            position: relative;

            .map-wrapper {
                height: 60vh;
                width: 60%;
                margin-left: 30%;
                min-height: 450px;

                .map {
                    height: 100%;
                    width: 100%;

                    background-image: url('../../assets/map.jpg');
                    background-size: cover;
                    background-position: center center;
                    background-repeat: no-repeat;
                }
            }
            .map-description-wrapper {
                position: absolute;
                top: 0;
                right: 50%;
                width: 50%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .map-description {
                    background-color: white;
                    padding: 50px;
                    width: 80%;
                    height: 80%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    .map-title {
                        font-size: 2rem;
                        color: rgb(52, 52, 52);
                        padding-bottom: 12px;
                    }

                    .map-content {
                        color: rgb(169, 169, 169);
                    }
                }

            }


            @media only screen and (max-width: 1200px) {

                padding-bottom: 5rem;

                .map-wrapper {
                    width: 100%;
                    margin: 0;
                    height: 40vh;
                    min-height: 350px;
                }

                .map-description-wrapper {
                    position: static;
                    width: 100%;
                    justify-content: center;
                    margin-top: -10%;

                    .map-description {
                        width: 80%;
                        padding: 20px;
                        .map-title {
                            font-size: 1.8rem;
                        }

                        .map-content {
                            font-size: 1.1rem;
                        }
                    }
                }
            }
        }
    }

</style>
